import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { tenantItem } from '../api/Workbenches/index';
import { getCurrentUser } from '../api/main';
interface userInfoType {
  name: string;
  id: string;
  corp_name: string;
  company_id: string;
  email: string;
  hide_phone: string;
  job_title: string;
  realname: string;
  dify_account_id: string;
  is_open_invitation: number | string;
  invite_code: string;
  avatar?: string;
}
interface appInfo {
  id?: string;
  title?: string;
  description?: string;
  avatar?: string;
  category_id: string;
  canvas_type?: string;
  dsl?: string | any;
}
export interface CounterState {
  value: number;
  userInfo: userInfoType;
  HomeInitLoading: boolean;
  showAddApp: boolean | string;
  currentSpace: tenantItem;
  resetCollect: boolean;
  setUpApp: boolean | string;
  setUpChat: boolean | string;
  appTitle: string;
}

const initialState: CounterState = {
  value: 0,
  userInfo: {
    avatar: '',
    name: '',
    id: '',
    corp_name: '',
    company_id: '',
    email: '',
    hide_phone: '',
    job_title: '',
    realname: '',
    dify_account_id: '',
    is_open_invitation: 1,
    invite_code: '',
  },
  HomeInitLoading: true,
  showAddApp: false,
  currentSpace: {
    name: '',
    id: '',
    realname: '',
    hide_phone: '',
    role: '',
    tenant_id: '',
    is_admin: '',
    created_at: '',
    corp_name: '',
    current: true,
  },
  resetCollect: true,
  setUpApp: false,
  setUpChat: false,
  appTitle: '',
};
export const fetchUserInfo = createAsyncThunk(
  'userInfo/fetchUserInfo',
  async () => {
    const response = await getCurrentUser();
    return response.data as userInfoType;
  },
);

export const counterSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    setCurrentSpace: (state, action) => {
      state.currentSpace = action.payload as tenantItem;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    setShowAddApp: (state, action) => {
      state.showAddApp = action.payload;
    },
    setProjectLoading: (state, action) => {
      state.HomeInitLoading = action.payload;
    },
    setResetCollect: (state, action) => {
      state.resetCollect = action.payload;
    },
    setShowSetUpApp: (state, action) => {
      state.setUpApp = action.payload;
    },
    setShowSetUpChat: (state, action) => {
      state.setUpChat = action.payload;
    },
    setShowAppTitle: (state, action) => {
      state.appTitle = action.payload;
    },
  },
  // .addCase(fetchUserInfo.pending, (state) => {
  //   state.HomeInitLoading = true;
  // })
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.userInfo = action.payload;
        state.HomeInitLoading = false;
      })
      .addCase(fetchUserInfo.rejected, (state) => {
        state.HomeInitLoading = false;
      });
  },
});

export const {
  increment,
  decrement,
  setCurrentSpace,
  setShowAddApp,
  setResetCollect,
  setProjectLoading,
  setShowSetUpApp,
  setShowSetUpChat,
  setShowAppTitle,
} = counterSlice.actions;
export default counterSlice.reducer;
